export enum StepCardStatusLabelEnum {
  ON_QUEUED = 'In Queue',
  AWAITING = 'Awaiting',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  CANCELLED = 'Cancelled',
  AUTO_APPROVED = 'Auto Approved'
}
